import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';


import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TrainingService {

  changeUtteranceType = new Subject<any>();
  updatedUtteranceEvent: EventEmitter<Object> = new EventEmitter();
  entitySearchListner = new Subject<string>();
  constructor(private http: HttpClient) { }
  node: Array<any> = [];

  getUtterance(agentId, propertyName, params) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/feature/' + propertyName + '/utterances', params)
  }

  listSmalltalk(agentId, query, smalltalk_query, limit, offset, type, sortKey=undefined, sortOrder=undefined) {
    let url = environment.va_training_api + 'ml/' + agentId + '/search_smalltalk?query=' + query + '&smalltalk_query=' + smalltalk_query + '&limit=' + limit + '&offset=' + offset;
    if(sortKey){
      url += '&sort_key=' + sortKey + '&sort_order=' + sortOrder
    }
    return this.http.get(url)
  }

  searchSmalltalk(agentId, query, limit, offset, sortKey=undefined, sortOrder=undefined) {
    let url = environment.va_training_api + 'ml/' + agentId + '/smalltalk/utterances/search?query=' + query + '&limit=' + limit + '&offset=' + offset;
    if(sortKey){
      url += '&sort_key=' + sortKey + '&sort_order=' + sortOrder
    }
    return this.http.get(url)
  }

  getUtteranceCount(agentId, propertyName) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/utterances/' + propertyName + '/count')
  }

  addUtterance(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/utterances', params)
  }

  //Get auto utterance list
  getAutoUtteranceList(params) {
    return this.http.post(environment.auto_utterance_url + 'generate_utterance', params)
  }

  //add auto utterance
  addAutoUtterance(agentId,featureId, params) {
    //https://ciradev.cognicor.com/training_service/ml/<project_id>/feature/<feature_id>/bulk_utterance
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/feature/'+featureId+'/bulk_utterance', params)
  }

  editUtterance(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/edit_utterance', params)
  }

  deleteUtterance(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/delete_utterance', params)
  }

  get_all_nodes(agentId, isIncludeRootConcept = false) {
    return this.http.get(environment.ontology_service_api + agentId + '/get_all_nodes/?include_root=' + isIncludeRootConcept)
      .pipe(
        map((response: Array<Object>) => {
          this.node = response;
          return response;
        })
      );
  }

 


  
  get_models(agentId) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/models')
  }

  get_model_config(agentId, model_name) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/models/' + model_name + '/config')
  }

  update_model_config(agentId, model_name, config) {
    return this.http.put(environment.va_training_api + 'ml/' + agentId + '/models/' + model_name + '/config', config)
  }

  delete_model_config(agentId, model_name) {
    return this.http.delete(environment.va_training_api + 'ml/' + agentId + '/models/' + model_name + '/config')
  }

  training(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/train', params)
  }

  checkStatus(agentId, taskId, parentId = null) {
    let url = environment.va_training_api + 'ml/' + agentId + '/status/' + taskId;
    if (parentId) {
      url += ('/' + parentId);
    }
    return this.http.get(url)
  }

  // change parent intent
  editUtteranceParent(agentId, params) {
    return this.http.put(environment.va_training_api + 'ml/' + agentId + '/change_parent_intent', params)
  }

  // testing
  testVA(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/test', params)
  }

  uploadCsv(agentId, files, CSVintent, CSVClearPrevious) {

    const formData: FormData = new FormData();
    formData.append('csv_file', files, files.name);

    let url = environment.va_training_api + 'ml/' + agentId + '/upload_template/' + CSVintent;

    if (CSVClearPrevious) {
      url += '/clean';
    }
    return this.http.post(url, formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  getQApairSmalltalk(agentId) {
    return this.http.get(environment.va_training_api + 'smalltalk/' + agentId + '/intents')
  }

  getSmalltalkTypeahead(agentId, term) {
    return this.http.get(environment.va_training_api + 'smalltalk/' + agentId + '/intents?detail=false&search=' + term)
  }

  uploadTestingCsv(agentId, csv_file) {

    const formData: FormData = new FormData();
    formData.append('csv_file', csv_file, csv_file.name);

    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/upload_test_csv', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  // Get Synonyms
  getSynonyms(agentId) {
    return this.http.get(environment.va_training_api + 'dictionary/' + agentId + '/synonyms')
  }

  // Upsert Synonyms
  insertSynonyms(agentId, params) {
    return this.http.post(environment.va_training_api + 'dictionary/' + agentId + '/synonyms', params)
  }
  // upload dictionary


  uploadSynonyms(agentId, csv_file, can_clear) {
    const formData: FormData = new FormData();
    formData.append('csv_file', csv_file, csv_file.name);
    formData.append('can_clear', can_clear)

    return this.http.post(environment.va_training_api + 'dictionary/' + agentId + '/synonyms/upload', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }


  downloadSynonyms(agentId) {
    return this.http.get(environment.va_training_api + 'dictionary/' + agentId + '/download_dictionary_csv_template')
  }



  // Upsert Synonyms
  updateSynonyms(agentId, id, params) {
    return this.http.put(environment.va_training_api + 'dictionary/' + agentId + '/synonyms/' + id, params)
  }

  // Delete Synonyms
  deleteSynonyms(agentId, id) {
    return this.http.delete(environment.va_training_api + 'dictionary/' + agentId + '/synonyms/' + id)
  }

  // get Utterance from cache
  getUtteranceValidate(agentId, utteranceLimit, dataOffset, quality = [], query = null) {
    let url = environment.va_training_api + 'testing/' + agentId + '/get_validation?limit=' + utteranceLimit + '&offset=' + dataOffset;
    if (quality != null && quality != undefined && quality.length != 0) {
      url += '&quality=' + JSON.stringify(quality);
    }
    if (query != null && query != undefined && query != '') {
      url += '&query=' + query;
    }
    return this.http.get(url)
  }

  // delete Utterance from cache
  deleteUtteranceValidate(agentId, itemId) {
    return this.http.delete(environment.va_training_api + 'testing/' + agentId + '/delete_validation/' + itemId)
  }

  // start Utterance Validate
  startUtteranceValidate(agentId) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/start_validation')
  }

  // serach Utterances
  getSearchValidation(agentId, query, limit, offset) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/get_validation/search?query=' + query + '&limit=' + limit + '&offset=' + offset)
  }

  // Get All Utterances
  getAllUtterances(agentId, taskId) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/status/' + taskId)
  }

  // Create testcase
  createTestcase(agentId, params) {
    return this.http.post(environment.va_training_api + 'testing/' + agentId + '/testcase', params)
  }

  // Get all testcase
  getTestcases(agentId, filter) {
    let params = new HttpParams()
    for (let key in filter){
      params = params.set(key, filter[key])
    }
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/testcase', {params: params})
  }

  // Edit testcase
  editTestcase(agentId, test_id, params) {
    return this.http.put(environment.va_training_api + 'testing/' + agentId + '/testcase/' + test_id, params)
  }

  // Delete testcase
  deleteTestcase(agentId, test_id) {
    return this.http.delete(environment.va_training_api + 'testing/' + agentId + '/testcase/' + test_id)
  }

  // Upload CSV testcase
  uploadTestcaseCSV(agentId, test_id, csv_file) {
    const formData: FormData = new FormData();
    formData.append('csv_file', csv_file, csv_file.name);

    return this.http.post(environment.va_training_api + 'testing/' + agentId + '/testcase/upload/' + test_id, formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  // Get all testcase
  testcaseTest(agentId, test_id) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/testcase/starttest/' + test_id)
  }

  // Get testcase status
  testcaseStatus(agentId, task_id) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/status/' + task_id)
  }

  //add auto suggestion

  addToAutoSuggestion(agentId,test_id,testcase_id,params){
    return this.http.post(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testcase_id +'/test/' + test_id + '/autosuggestion', params)
  }

  getTestData(agentId, test_id, params = {}) {
    return this.http.post(environment.va_training_api + 'testing/' + agentId + '/testcase/' + test_id + '/tests', params)
  }

  // create a test data
  createTestData(agentId, test_id, params) {
    return this.http.post(environment.va_training_api + 'testing/' + agentId + '/testcase/' + test_id + '/test', params)
  }

  searchTestCaseName(agentId, term) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/testcase/search?term='+ term)
  }

  // update a test data
  updateTestData(agentId, test_id, params, testcase_id) {
    return this.http.put(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testcase_id + '/test/' + test_id, params)
  }

  // Delete a test data
  deleteTestData(agentId, test_id, testcase_id) {
    return this.http.delete(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testcase_id + '/test/' + test_id)
  }
  // search a test data
  searchTestData(data) {
    return this.http.get(environment.va_training_api + 'testing/' + data.agentId + '/testcase/' + data.testId + '/search?query=' + data.testCaseQuery + '&limit=' + data.DataLimit + '&offset=' + data.dataOffset)
  }

  // get all tags
  getAllTags(agentId, testcase_id, params) {
    return this.http.post(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testcase_id + '/tags', params)
  }
  getAllTopics(agentId, testcase_id) {
    return this.http.get(`${environment.va_training_api}testing/${agentId}/testcase/${testcase_id}/topics`)
  }
  getAllDocuments(agentId, testcase_id) {
    return this.http.get(`${environment.va_training_api}testing/${agentId}/testcase/${testcase_id}/documents`)
  }
  getAllIntents(agentId, testcase_id) {
    return this.http.get(`${environment.va_training_api}testing/${agentId}/testcase/${testcase_id}/intents`)
  }
  getAllSubfeatures(agentId, testcase_id) {
    return this.http.get(`${environment.va_training_api}testing/${agentId}/testcase/${testcase_id}/subfeatures`)
  }
  runTest(agentId, testcase_id, test_id) {
    return this.http.get(`${environment.va_training_api}testing/${agentId}/testcase/starttest/${testcase_id}/execute/${test_id}`)
  }


  /**
   * New set of services (V2)
   */

  // add utterance
  _addUtterance(agentId, property_type, property_name, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/' + property_type + '/' + property_name + '/utterances', params)
  }

  // get utterance
  _getUtterance(agentId, property_type, property_name) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/' + property_type + '/' + property_name + '/utterances')
  }

  // delete utterance
  _deleteUtterance(agentId, property_type, property_name, utteranceId) {
    return this.http.delete(environment.va_training_api + 'ml/' + agentId + '/' + property_type + '/' + property_name + '/utterances/' + utteranceId)
  }

  // update utterance
  _updateUtterance(agentId, property_type, property_name, utteranceId, params) {
    return this.http.put(environment.va_training_api + 'ml/' + agentId + '/' + property_type + '/' + property_name + '/utterances/' + utteranceId, params)
  }

  // get utterance count
  _getUtteranceCount(agentId, property_type) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/' + property_type + '/utterances/count')
  }

  // download utteranes template
  _downloadUtteranceTemplate(agentId, intent_type) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/download_template/' + intent_type)
  }

  // download utterance CSV url
  getDownloadUtteranceCSVUrl(agentId, intent_type, CSVUrl) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/download_template/' + intent_type + CSVUrl)
  }

  // get conflict list
  getconflictList(agentId, conflict_item_id) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/' + conflict_item_id + '/get_conflict_items')
  }

  // upload utteranes template
  _uploadUtteranceTemplate(agentId, intent_type, file, upload_type) {
    const formData: FormData = new FormData();
    formData.append('csv_file', file, file.name);
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/upload_template/' + intent_type + upload_type, formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  // get utterance entities
  _getEntities(agentId) {
    return this.http.get(environment.va_training_api + 'ml/' + agentId + '/entities')
  }

  // create utterance entities
  _createEntities(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/entities', params)
  }

  // delete utterance entities
  _deleteEntities(agentId, entityId) {
    return this.http.delete(environment.va_training_api + 'ml/' + agentId + '/entities/' + entityId)
  }

  getUserLogList(params) {

    return this.http.post(environment.analytics_api + 'chat_log', params)
  }
  searchUserLogList(params) {

    return this.http.post(environment.analytics_api + 'chatlog_search', params)
  }

  getFullChat(params) {

    return this.http.post(environment.analytics_api + 'full_chats', params)
  }

  // Get all NER utterances
  getNerUtterances(agentId, limit, offset) {
    return this.http.get(
      environment.va_training_api + 'entity/' + agentId + '/ner_utterance/list?offset=' + offset + '&limit=' + limit)
  }

  // Create all NER utterances
  createNerUtterances(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/ner_utterances', params)
  }

  // Delete all NER utterances
  deleteNerUtterances(agentId, utteranceId) {
    return this.http.delete(environment.va_training_api + 'ml/' + agentId + '/ner_utterances/' + utteranceId)
  }

  // Update all NER utterances
  updateNerUtterances(agentId, utteranceId, params) {
    return this.http.put(environment.va_training_api + 'ml/' + agentId + '/ner_utterances/' + utteranceId, params)
  }

  // Create all NER utterances in chat annotator
  annotatorNerUtterances(agentId, params) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/ner_utterances_annotator', params)
  }

  sendQuestion(agent_id, params) {

    return this.http.post(environment.va_service_api + 'retraining_module/' + agent_id + '/assign_qa', params)
  }
  getAssignInfo(agent_id, params) {

    return this.http.post(environment.va_service_api + 'retraining_module/' + agent_id + '/get_assign_info', params)
  }

  // /Save Questions and answer in retaraining
  saveQuestionAnswers(agent_id, question_id, params) {
    return this.http.post(environment.va_service_api + 'retraining_module/' + agent_id + '/' + question_id + '/qa', params)
  }

  // /retraining_module/<ObjectId:id>/questions/view_similar_questions

  getSimilarQuestions(agent_id, params) {
    return this.http.post(environment.va_service_api + 'retraining_module/' + agent_id + '/view_similar_questions', params)
  }

  setChatFlag(params) {
    return this.http.post(environment.analytics_api + 'mark_fav', params)
  }

  setChatImportant(params) {
    return this.http.post(environment.analytics_api + 'mark_important', params)
  }

  deleteChatLog(agent_id, chat_id) {
    return this.http.delete(environment.analytics_api + agent_id + '/' + chat_id + '/delete')
  }

  // get test-case rule lists
  getTestcaseRuleList(agent_id, test_id) {
    return this.http.get(environment.va_training_api + 'testing/' + agent_id + '/testcase/' + test_id + '/testcase_rule')
  }

  // add test-case rule
  addTestcaseRule(agent_id, test_id, params) {
    return this.http.post(environment.va_training_api + 'testing/' + agent_id + '/testcase/' + test_id + '/testcase_rule', params)
  }

  // edit test-case rule
  editTestcaseRule(agent_id, test_id, rule_id, params) {
    return this.http.put(environment.va_training_api + 'testing/' + agent_id + '/testcase/' + test_id + '/testcase_rule/' + rule_id, params)
  }

  // delete test-case rule
  deleteTestcaseRule(agent_id, test_id, rule_id) {
    return this.http.delete(environment.va_training_api + 'testing/' + agent_id + '/testcase/' + test_id + '/testcase_rule/' + rule_id)
  }

  getTopicSynonyms(agent_id) {
    return this.http.get(environment.va_training_api + 'ml/' + agent_id + '/topic_synonyms')
    }

  getRegexlist(agentId: string, entity: string) {
    return this.http.get(environment.va_training_api + 'entity/' + agentId + '/regex/list/' + entity)
  }

  getTestCaseHistory(agentId, testCaseID) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testCaseID + '/history')
    }

  createRegex(agentId: string, params: any) {
    return this.http.post(environment.va_training_api + 'entity/' + agentId + '/regex/add', params)
  }

  getTestHistory(agentId, testID, testCaseID) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testCaseID + '/test/' + testID + '/history')
    }
    
  updateRegex(agentId: string, regexId: string, params) {
    return this.http.post(environment.va_training_api + 'entity/' + agentId + '/regex/edit/' + regexId, params)
  }

  deleteRegex(agentId: string, regexId: string) {
    return this.http.delete(environment.va_training_api + 'entity/' + agentId + '/regex/delete/' + regexId)
  }

  searchEntity(agentId: string, searchQuery: string) {
    return this.http.get(environment.va_training_api + 'entity/' + agentId + '/entities/search?query=' + searchQuery)
  }

  searchUtterence(agentId: string, utterenceKey: string, entityKey: string) {
    return this.http.get(
      environment.va_training_api + 'entity/' + agentId + '/ner_utterances/search?utterance=' + utterenceKey + '&entity=' + entityKey)
  }

  nerTraining(agentId: string) {
    return this.http.post(environment.va_training_api + 'ml/' + agentId + '/train_ner', {})
  }

  trainingResponse(agentId, testCaseId, testId) {
    return this.http.get(environment.va_training_api + 'testing/' + agentId + '/testcase/' + testCaseId +
     '/test/' + testId + '/va_response')
  }


  // Document abbreviations
  getAbbreviations(agentId) {
    return this.http.get(environment.va_training_api + 'document_abbreviation/' + agentId + '/abbreviation')
  }

  insertAbbreviations(agentId, params) {
    return this.http.post(environment.va_training_api + 'document_abbreviation/' + agentId + '/abbreviation', params)
  }

  updateAbbreviations(agentId, id, params) {
    return this.http.put(environment.va_training_api + 'document_abbreviation/' + agentId + '/abbreviation/' + id, params)
  }

  deleteAbbreviations(agentId, id) {
    return this.http.delete(environment.va_training_api + 'document_abbreviation/' + agentId + '/abbreviation/' + id)
  }

  downloadAbbreviations(agentId) {
    return this.http.get(environment.va_training_api + 'document_abbreviation/' + agentId + '/download')
  }

  uploadAbbreviations(agentId, csv_file, can_clear) {
    const formData: FormData = new FormData();
    formData.append('csv_file', csv_file, csv_file.name);
    formData.append('can_clear', can_clear)

    return this.http.post(environment.va_training_api + 'document_abbreviation/' + agentId + '/upload', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }




}
